
<div *ngIf="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-md relative">
      <h2 class="text-xl font-bold mb-4">{{'words.rate-this-course' | translate}}</h2>
  
      <!-- Estrellas -->
      <div class="flex gap-2 mb-4 cursor-pointer text-2xl">
        <ng-container *ngFor="let star of [1,2,3,4,5]">
          <span 
            class="transition-colors" 
            [ngClass]="(hoverRating >= star || selectedRating >= star) ? 'text-yellow-400' : 'text-gray-300'"
            (mouseenter)="setHover(star)" 
            (mouseleave)="resetHover()" 
            (click)="setRating(star)">
            &#9733;
          </span>
        </ng-container>
      </div>
  
      <!-- Comentario -->
      <textarea [(ngModel)]="comment" rows="3" [placeholder]="'words.comment-rating' | translate"
        class="w-full border rounded p-2 mb-4" style="resize: none;"></textarea>
  
      <!-- Botones -->
      <div class="flex justify-between">
        <button (click)="close()" class="text-gray-600 text-sm">{{'common.cancel' | translate}}</button>
        <button (click)="submit()" [disabled]="selectedRating === 0"
          class="bg-secondary-500 text-sm text-white px-4 py-2 rounded hover:bg-secondary-700 cursor-pointer btn-transition">{{'word.submit' | translate}}</button>
      </div>
    </div>
  </div>
